module.exports = __webpack_public_path__ + "img/p3.506417be.png";